export {default as dispatch} from "./src/dispatch";



//////////////////
// WEBPACK FOOTER
// ../~/d3-dispatch/index.js
// module id = l+iB
// module chunks = 0